import {query} from "@/graphql/client";
import {EmployeeMonthSummary, EmployeeMonthSummaryFragment} from "@/graphql/generated/graphql";
import {kapitelMonthString} from "@/graphql/kapitelTypes";
import {graphql} from "@/graphql/generated";

export const employeeMonthSummary = graphql(`fragment EmployeeMonthSummary on EmployeeMonthSummary {
    month
    
    bookingTarget
    cntAZKDays
    cntBookings
    cntSicknessDays
    cntVacationDays
    productiveHours
    absenceDayHoursFloat
}`)


export async function fetchEmployeeMonthSummary(month: kapitelMonthString): Promise<EmployeeMonthSummaryFragment> {
    const result = await query(
        graphql(`query getEmployeeMonthSummary($month: KapitelDateImmutable!) {            
            employeeMonthSummary(month: $month) {
                ...EmployeeMonthSummary
            }
        }`),
        {month}
    )

    return result.data.employeeMonthSummary
}

export async function fetchEmployeeMonthSummaries(begin: kapitelMonthString, until: kapitelMonthString): Promise<EmployeeMonthSummaryFragment[]> {
    const result = await query(
        graphql(`query getEmployeeMonthSummaries($begin: KapitelDateImmutable!, $until: KapitelDateImmutable!) {            
            employeeMonthSummaries(begin: $begin, until: $until) {
                ...EmployeeMonthSummary
            }
        }`),
        {begin, until}
    )

    return result.data.employeeMonthSummaries
}
